import { queryKeyPrefix } from 'src/features/tanStackQuery/queryKeyPrefix'
import { PaginationState } from 'src/hooks/useListPagination'

const prefix = queryKeyPrefix.userGroups

export const queryKeys = {
  userGroupsAll: [...prefix, 'userGroups'],
  userGroups: (filters: PaginationState) =>
    [...prefix, 'userGroups', filters] as const,
}
